export default __webpack_public_path__ + "static/simple-line-09e95ea835b85e1e5dc8395284f771e3.png";